var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMapPinHexagonLight({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M45.2783 6.5L57.5 18.7217V39.2783L45.2783 51.5H24.7217L12.5 39.2783V18.7217L24.7217 6.5H45.2783Z",
    stroke: "url(#paint0_linear_2381_6077)",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M45.4854 5C45.7505 5.00004 46.0049 5.10547 46.1924 5.29297L58.707 17.8076C58.8945 17.9951 59 18.2495 59 18.5146V29H11V18.5146C11 18.2495 11.1055 17.9951 11.293 17.8076L23.8076 5.29297C23.9951 5.10547 24.2495 5.00004 24.5146 5H45.4854Z",
    fill: "url(#paint1_linear_2381_6077)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2381_6077",
    x1: 35,
    y1: 5,
    x2: 35,
    y2: 53,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2381_6077",
    x1: 35,
    y1: 5,
    x2: 35,
    y2: 29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapPinHexagonLight);
export default __webpack_public_path__ + "static/media/map_pin_hexagon_light.43e1b1bf996265ea83cbcf64dc57f3d4.svg";
export { ForwardRef as ReactComponent };